import { createDatasetUnit } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_PLATFORM_VERSIONS,
  PLATFORM_VERSIONS_STORE,
  PLATFORM_VERSIONS_STORE_LIST,
} from '../constants';

const api = (queryParams) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: API_PLATFORM_VERSIONS,
    useProxy: false,
    queryParams,
  }).then((versions) => ({ data: versions }));

const platformVersionsStore = createDatasetUnit({
  api,
  storeName: PLATFORM_VERSIONS_STORE,
  actionName: PLATFORM_VERSIONS_STORE_LIST,
});

export default platformVersionsStore;
